// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2o1J_","footer":"ReportModalFilter_footer__TUi_M"};